import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  Dimmer,
  Loader,
  Transition,
  Icon,
} from "semantic-ui-react";
import { Link } from "react-router-dom";

// import { ModalAnuncios } from "../../components";
import "./Inicio.scss";
import imagen from "../../images/imagenHomeAgenda.jpg";

export function Inicio() {
  const [imagenCargada, setImagenCargada] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    setVisible(true);
  }, []);

  const cargaImagen = () => {
    setImagenCargada(true);
  };

  return (
    <>
      <Dimmer active={!imagenCargada} inverted>
        <Loader size="big">Espere un momento</Loader>
      </Dimmer>
      {/* <ModalAnuncios /> */}
      <Grid
        className="gridInicio"
        stackable
        columns={2}
        verticalAlign="middle"
        textAlign="center"
        style={{
          display: imagenCargada ? "flex" : "none",
        }}
      >
        <Transition animation="scale" duration={1000} visible={visible}>
          <Grid.Column>
            <p className="tituloGrande">MINISTERIO DE SALUD DE JUJUY</p>
            <p className="tituloMediano">UNIDAD DE DOCENCIA</p>
            <p className="tituloPequenio">
              Para conocer tanto las propuestas de capacitación presenciales,
              semipresenciales y en línea haga clic en el siguiente botón:
            </p>
            <Button className="buttonFormat" as={Link} to={"/agenda"}>
              <Icon name="calendar alternate outline" />
              Ir a la Agenda Única de Capacitación
            </Button>
          </Grid.Column>
        </Transition>
        <Transition animation="scale" duration={1000} visible={visible}>
          <Grid.Column style={{ padding: "0px" }}>
            <img
              className="imagenHome"
              alt=""
              src={imagen}
              onLoad={cargaImagen}
            ></img>
          </Grid.Column>
        </Transition>
      </Grid>
    </>
  );
}
